import isEmail from 'validator/lib/isEmail';
import isURL from 'validator/lib/isURL';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const urlValidator = message => {
	return (value, isDirty) => {
		if (value && isDirty && !isURL(value)) {
			return message;
		}
	};
};

export default {

	COMPANY_NAME: [
		{
			key: 'company:companyname',
			placeholder: localize('smartfields-team-name-placeholder')
		}
	],

	EMAIL: [
		{
			key: 'company:email',
			placeholder: localize('smartfields-email-placeholder'),
			validator: (value, isDirty) => {
				if (value && isDirty && !isEmail(value)) {
					return localize('smartfields-email-invalid');
				}
			}
		}
	],

	ADDRESS: [
		{
			key: 'company:addressline1',
			placeholder: localize('smartfields-address1-placeholder')
		},
		{
			key: 'company:city',
			placeholder: localize('smartfields-city-placeholder')
		},
		{
			key: 'company:region',
			placeholder: localize('smartfields-region-placeholder')
		},
		{
			key: 'company:postcode',
			placeholder: localize('smartfields-postcode-placeholder')
		},
		{
			key: 'company:country',
			placeholder: localize('smartfields-country-placeholder')
		}
	],

	PHONE_NUMBER: [
		{
			key: 'company:telephone',
			placeholder: localize('smartfields-phone-placeholder'),
			validator: (value, isDirty) => {
				// eslint-disable-next-line no-useless-escape
				if (value && isDirty && value.match(/^[0-9\-\+\(\)\s]*$/) === null) {
					return localize('smartfields-phone-invalid');
				}
			}
		}
	],

	WEBSITE: [
		{
			key: 'company:website',
			placeholder: localize('smartfields-website-placeholder'),
			// eslint-disable-next-line
			validator: urlValidator(localize('smartfields-website-invalid'))
		}
	],

	INSTAGRAM: [
		{
			key: 'company:instagram:link',
			description: localize('smartfields-social-link-description'),
			placeholder: localize('smartfields-instagram-link-placeholder'),
			validator: urlValidator(localize('smartfields-instagram-link-invalid'))
		},
		{
			key: 'company:instagram:text',
			description: localize('smartfields-social-name-description'),
			prefix: '@',
			placeholder: localize('smartfields-instagram-name-placeholder')
		}
	],

	FACEBOOK: [
		{
			key: 'company:facebook:link',
			description: localize('smartfields-social-link-description'),
			placeholder: localize('smartfields-facebook-link-placeholder'),
			validator: urlValidator(localize('smartfields-facebook-link-invalid'))
		},
		{
			key: 'company:facebook:text',
			description: localize('smartfields-social-name-description'),
			prefix: '@',
			placeholder: localize('smartfields-facebook-name-placeholder')
		}
	],

	TWITTER: [
		{
			key: 'company:twitter:link',
			description: localize('smartfields-social-link-description'),
			placeholder: localize('smartfields-twitter-link-placeholder'),
			validator: urlValidator(localize('smartfields-twitter-link-invalid'))
		},
		{
			key: 'company:twitter:text',
			description: localize('smartfields-social-name-description'),
			prefix: '@',
			placeholder: localize('smartfields-twitter-name-placeholder')
		}
	],

	LINKEDIN: [
		{
			key: 'company:linkedin:link',
			description: localize('smartfields-social-link-description'),
			placeholder: localize('smartfields-linkedin-link-placeholder'),
			validator: urlValidator(localize('smartfields-linkedin-link-invalid'))
		},
		{
			key: 'company:linkedin:text',
			description: localize('smartfields-social-name-description'),
			placeholder: localize('smartfields-linkedin-name-placeholder')
		}
	]

};



// WEBPACK FOOTER //
// ./src/containers/SmartFields/SmartFieldsSchema.js